/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import NewChevronDown from "assets/svgs/NewChevronDown";
import clsx from "clsx";
import { useState } from "react";

const FilterCategoryShell = ({
	label,
	subLabel,
	content,
	filterExpanded = true,
	filterDisabled = false,
	hideDivider = false,
	isFilterApplied = false,
	filterCount = 0,
}: {
	label: string;
	subLabel?: string;
	content: any;
	filterExpanded?: boolean;
	filterDisabled?: boolean;
	hideDivider?: boolean;
	isFilterApplied?: boolean;
	filterCount?: number;
}) => {
	const [isFilterExpanded, setIsFilterExpanded] = useState(filterExpanded);

	return (
		<div className="space-y-[12px] text-sm leading-[20px]">
			<div
				className="flex cursor-pointer items-center justify-between"
				onClick={() => !filterDisabled && setIsFilterExpanded(!isFilterExpanded)}
			>
				<div className="flex items-center gap-[4px]">
					<p
						className={clsx("m-0 font-semibold", {
							"text-[#B8B0B9]": filterDisabled,
						})}
					>
						{label}
					</p>
					{isFilterApplied && (
						<div className="flex h-[20px] w-[20px] items-center justify-center rounded-full bg-[#FFF2EB]">
							<p className="m-0 text-xs leading-[16px] text-[#842000]">
								{filterCount}
							</p>
						</div>
					)}
				</div>

				<div
					className={clsx("-rotate-180 duration-300", {
						"rotate-0": isFilterExpanded,
					})}
				>
					<NewChevronDown fill={filterDisabled ? "#D1CED4" : "#8C8594"} />
				</div>
			</div>
			<div className="text-sm leading-[20px] text-[#8C8594]">{subLabel}</div>
			<div className={isFilterExpanded ? "block" : "hidden"}>{content}</div>
			{!hideDivider && <div className="h-[1px] w-full bg-[#E8E7EA]" />}
		</div>
	);
};

export default FilterCategoryShell;
